module.exports = __webpack_public_path__ + "img/premium-button.5ac15e5a.png";